import {
  FaSignOutAlt,
  FaTachometerAlt,
  FaUser,
  FaUsers,
  FaUtensils,
  FaMoneyBill,
  FaCog,
  FaTruck,
  FaMapMarkerAlt,
  FaShoppingBasket,
  FaHeadset,
  FaListAlt,
  FaLocationArrow,
} from "react-icons/fa";

export const navlinks = [
  {
    to: "dashboard",
    icon: <FaTachometerAlt />,
    name: "Dashboard",
  },
  {
    to: "users",
    icon: <FaUser />,
    name: "User Management",
  },
  {
    to: "agents",
    icon: <FaUsers />,
    name: "Agent Management",
  },
  {
    to: "restaurants",
    icon: <FaUtensils />,
    name: "Restaurant Management",
  },
  {
    to: "logistics",
    icon: <FaTruck />,
    name: "Logistics",
  },
  {
    to: "orders",
    icon: <FaListAlt />,
    name: "All Orders",
    badge: true,
  },
  {
    to: "notification",
    icon: <FaShoppingBasket />,
    name: "Order",
    badge: true,
  },
  /*
  {
    to: 'delivery-location',
    icon: <FaMapMarkerAlt />,
    name: 'Delivery Location'
  },
  */
  {
    to: "assign-rider",
    icon: <FaMapMarkerAlt />,
    name: "Assign Rider",
  },
  {
    to: "agent-live-tracking",
    icon: <FaLocationArrow />,
    name: "Agent Live Location",
  },
  {
    to: "active-riders",
    icon: <FaTruck />,
    name: "Live Rider Tracking",
  },
  {
    to: "finances",
    icon: <FaMoneyBill />,
    name: "Finances",
  },
  {
    to: "settings",
    icon: <FaCog />,
    name: "Settings",
  },
  {
    to: "support",
    icon: <FaHeadset />,
    name: "Customer Support",
  },

  {
    to: "logout",
    icon: <FaSignOutAlt />,
    name: "Logout",
  },
];

// Nigerian states for filtering across all components
export const NIGERIAN_STATES = [
  "all",
  "Abuja",
  // "Lagos",
  // "Kano",
  // "Kaduna",
  // "Katsina",
  // "Oyo",
  // "Rivers",
  // "Bauchi",
  // "Jigawa",
  // "Benue",
  // "Anambra",
  // "Borno",
  // "Sokoto",
  // "Kebbi",
  // "Zamfara",
  // "Yobe",
  // "Gombe",
  // "Taraba",
  // "Plateau",
  // "Nasarawa",
  // "Niger",
  // "Kwara",
  // "Kogi",
  // "Edo",
  // "Delta",
  // "Cross River",
  // "Akwa Ibom",
  // "Imo",
  // "Abia",
  "Enugu",
  // "Ebonyi",
  // "Adamawa",
  // "FCT",
];
